import { IUserAccountInterface } from '../../client';

export interface IShipstationApiCredential {
  api_key :string;
  api_secret :string;
}

export interface IShipkeyApiCredential {
  api_token :string;
}

export interface IShopifyApiCredential {
  shopify_api_key :string;
  shopify_api_secret :string;
  shopify_store_url :string;
}

export interface IAppIntegrationAccount {
  id :number;
  label :string;
  app :string;
  createdAt :Date;
  updatedAt :Date;
  authType :string;
  credentials :IShipstationApiCredential | IShipkeyApiCredential | any;
  settings :any; // TODO: Define settings interface
  createdBy :IUserAccountInterface;
  updatedBy :IUserAccountInterface;
  channelIntegrationMappingsCount :number;
  channelIntegrationMappings :any[];
}

export interface IAppIntegrationAccountType {
  name :string;
  authType :string;
}

export interface IAppIntegrationAccountProduct {
  id :number;
  lumSkuId :number;
  lumSku :any;
  productId :string;
  appIntegrationAccountId :number;
  variantId :string;
  sku :string;
  productName :string;
  inventoryItemId :string;
  gtin ?:any;
  warehouseLocationId ?:any;
  warehouseCustomerId ?:any;
  currentInventory ?:any;
  price ?:any;
  lumStatus :string;
  remoteStatus :string;
  bufferQuantity ?:any;
  leadtimeDays ?:any;
  createdAt :string;
  updatedAt :string;
}

export enum EAppIntegrationAccountProductFilter {
  ALL = 'ALL',
  SKU = 'SKU',
  NOT_MAPPED = 'NOT_MAPPED',
}

export interface IAppIntegrationAccountCompany {
  id :number;
  lumCompany :any;
  lumCompanyId :number;
  companyId :string;
  remoteReferenceIdentifier :string;
  appIntegrationAccountId :number;
  name :string;
  createdAt :string;
  updatedAt :string;
  deletedAt :string;
}

export enum EAppIntegrationAccountCompanyFilter {
  ALL = 'ALL',
  COMPANY = 'COMPANY',
  NOT_MAPPED = 'NOT_MAPPED',
}

export interface IAppIntegrationAccountSettings {
  appIntegrationAccountId :number;
  key :string;
  value :any;
}
